export default __webpack_public_path__ + "static/media/emtyCard.adbc8885.svg";